"use client";

import { ReactNode } from "react";

import { ContentfulLivePreviewProvider } from "@contentful/live-preview/react";

interface ContentfulLivePreviewGateProps {
  children: ReactNode;
}

export function ContentfulLivePreviewGate({ children }: ContentfulLivePreviewGateProps) {
  return <ContentfulLivePreviewProvider locale="en-US">{children}</ContentfulLivePreviewProvider>;
}
